import React, { useMemo } from 'react'
import { SelectDropdown } from '../../../../../../components/SelectDropdown/SelectDropdown'
import { nanoid } from 'nanoid'
import { Form } from 'react-bootstrap'
import { WidgetProps } from '@rjsf/utils'
import { CustomWidgetProps } from '../FormCitation/FormCitation'

export const CustomSingleChoiceWidget: React.FC<WidgetProps> = (props) => {
  const { schema, onChange, value } = props
  const { isEditing, fieldContainerClass, citationButton } = props.options as CustomWidgetProps

  const enumValues = useMemo(() => {
    return schema?.enum?.map((option) => (option ? String(option) : 'No relevant information detected')) || []
  }, [schema])

  const options = useMemo(
    () =>
      enumValues.map((enumValue) => ({
        label: enumValue,
        value: enumValue,
        id: nanoid(),
      })),
    [enumValues],
  )
  const selectedOption = useMemo(() => options.find((option) => option.value === value) || null, [options, value])

  return isEditing ? (
    <SelectDropdown
      className='zocks-px-0.75 py-2 zocks-border-color-gray-500'
      options={options}
      initialSelectedOption={selectedOption}
      onOptionSelected={(option) => {
        if (onChange) {
          onChange(option.label)
        }
      }}
    />
  ) : (
    <div className={fieldContainerClass}>
      <Form.Control type='text' value={value} disabled={true} className='form-control disabled-contact-information-field border-0' />
      {!isEditing && value ? citationButton : null}
    </div>
  )
}
